import { render, staticRenderFns } from "./PortfolioCreationDateInfoDrawer.vue?vue&type=template&id=7a8743c9&scoped=true"
import script from "./PortfolioCreationDateInfoDrawer.vue?vue&type=script&lang=js"
export * from "./PortfolioCreationDateInfoDrawer.vue?vue&type=script&lang=js"
import style0 from "./PortfolioCreationDateInfoDrawer.vue?vue&type=style&index=0&id=7a8743c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8743c9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InfoIcon: require('/skade-pwa/components/ui/atom/InfoIcon.vue').default})
